import { getPaginated, getApi } from 'util/backendapi/fetch';
import {
  makeReportingDuck,
  ReportingDuckActions,
} from 'ducks/make-reporting-duck';

export const storedPlotListDuck = makeReportingDuck(
  'storedPlots',
  (filters) => getPaginated('/reports/stored-plots/', filters),
  () => getApi('/reports/stored-plots/info/')
);

export type StoredPlotListAction = ReportingDuckActions<
  typeof storedPlotListDuck
>;
